import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { QNSIcon, NFTIcon } from '../assets/icons/ServiceIcons';
import { NotifyModal } from './NotifyModal';
import './ServicesGrid.css';

interface Service {
  id: 'qns' | 'nft';
  icon: React.ReactNode;
  title: string;
  description: string;
  status?: 'live' | 'coming-soon';
}

export const ServicesGrid: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<'qns' | 'nft' | 'general'>('general');

  const openModal = (productId: 'qns' | 'nft') => {
    setSelectedProduct(productId);
    setModalOpen(true);
  };

  const services: Service[] = [
    {
      id: 'qns',
      icon: <QNSIcon size={80} />,
      title: 'QNS Domain Service',
      description: 'Human-readable addresses for Qubic. Replace complex wallet addresses with simple, memorable names.',
      status: 'coming-soon',
    },
    {
      id: 'nft',
      icon: <NFTIcon size={80} />,
      title: 'NFT Gallery',
      description: 'Explore NFT collections. Discover, trade, and showcase digital art.',
      status: 'coming-soon',
    },
  ];

  return (
    <section className="services-section" id="products">
      <div className="services-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title gradient-text">Our Products</h2>
          <p className="section-subtitle">
            Community-built tools on the world's fastest blockchain
          </p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              {service.status === 'coming-soon' ? (
                <button
                  className="service-link service-link-button"
                  onClick={() => openModal(service.id)}
                >
                  Get Notified
                </button>
              ) : (
                <span className="service-link">Explore</span>
              )}
              {service.status === 'coming-soon' && (
                <span className="coming-soon-badge">Coming Soon</span>
              )}
            </motion.div>
          ))}
        </div>
      </div>

      <NotifyModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        defaultProduct={selectedProduct}
      />
    </section>
  );
};
